import CabinetShell from '../../features/cabinet/CabinetShell';
import { SMM_MANAGER_CABINET } from '../../features/cabinet/configs';

export default function SmmManagerPage() {
  return <CabinetShell config={SMM_MANAGER_CABINET} />;
}
